// eslint-disable-next-line import/no-duplicates
import moment from 'moment-timezone';
// eslint-disable-next-line import/no-duplicates
import { RelativeTimeSpec } from 'moment-timezone';

import { MomentSecondsReplacements } from './time-translations';

type MomentNamespace = typeof moment;

function patchMomentRelativeSeconds(
  locale: string,
  updatedWord: string,
  moment: MomentNamespace,
): void {
  const relativeTime = <RelativeTimeSpec>{ ...(<any>moment.localeData(locale))._relativeTime };
  if (relativeTime.s === updatedWord) {
    return;
  }

  const replaceFn = (relativeTimeProp: 'future' | 'past') => (value: string) => {
    if (value !== updatedWord) {
      const interpolatedValue = (<string>relativeTime[relativeTimeProp]).replace(/%s|%d/g, value);
      return relativeTimeProp === 'future'
        ? interpolatedValue[0].toUpperCase() + interpolatedValue.slice(1)
        : interpolatedValue;
    }

    return value;
  };

  moment.updateLocale(locale, {
    relativeTime: {
      future: replaceFn('future'),
      past: replaceFn('past'),
      s: updatedWord,
    },
  });
}

export const patchMoment = (moment: MomentNamespace) => {
  patchMomentRelativeSeconds('en', MomentSecondsReplacements.EN, moment);
  patchMomentRelativeSeconds('de', MomentSecondsReplacements.DE, moment);
  patchMomentRelativeSeconds('fr', MomentSecondsReplacements.FR, moment);
  patchMomentRelativeSeconds('nl', MomentSecondsReplacements.NL, moment);
  patchMomentRelativeSeconds('fi', MomentSecondsReplacements.FI, moment);
  patchMomentRelativeSeconds('sv', MomentSecondsReplacements.SV, moment);
};
